/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/hook-use-state */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect } from "react";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import httpClient from "utils/apis/http-client";
import { showToast } from "utils/helper";
import { Button, Combobox, DatePicker, Input } from "@repo/ui";
import { API_URL, PREV_DAY_DATE } from "utils/constant";
import { formatDate } from "date-fns";

const apiUrl = API_URL;

function AssetsIssuance({ onAssetIssued }: any) {
  const currentDate = new Date();

  const [ddlAssetTypes, setDdlAssetTypes] = useState("");
  const [assetTypes, setAssetTypes] = useState([]);

  const [assetNos, setAssetsNos] = useState([]);
  const [selectedAssetNos, setSelectedAssetsNos] = useState([]);

  const [issueDate, setIssueDate] = useState(currentDate);
  const [employeeId, setEmployeeId] = useState("");
  const [txtEmployeeIdColor, setTxtEmployeeIdColor] = useState("");
  const [isValidEmployee, setIsValidEmployee] = useState(false);

  const [btnConfirmText, setBtnConfirmText] = useState("Confirm");
  const [btnConfirmDisabled, setBtnConfirmDisabled] = useState(true);

  const getAssetTypesList = async () => {
    const assetsListEndpoint = `${apiUrl}/resources/assets/types`;

    try {
      await httpClient.get(assetsListEndpoint).then((res) => {
        if (res.status === 200) {
          const result = res.data.map((m: any) => ({
            value: m.description,
            label: m.description,
          }));

          setAssetTypes(result);
        } else {
          setAssetTypes([]);
          showToast("error", "Unable to load asset types.");
        }
      });
    } catch (err) {
      setAssetTypes([]);
      showToast("error", "Unable to load asset types.");
    }
  };

  const getAssetsList = async (assetType: string) => {
    const assetsListEndpoint = `${apiUrl}/resources/assets/list/${assetType}`;

    try {
      await httpClient.get(assetsListEndpoint).then((res) => {
        if (res.status === 200) {
          const result = res.data.map((m: any) => ({
            assetNo: m.assetNo,
            description: m.description,
            assetType: m.assetType,
            serialNo: m.serialNo,
          }));

          setAssetsNos(result.map((ast: any) => `${ast.assetNo}`));
        } else {
          setAssetsNos([]);
          showToast("error", "Unable to load assets.");
        }
      });
    } catch (err) {
      setAssetsNos([]);
      showToast("error", "Unable to load assets.");
    }
  };

  useEffect(() => {
    getAssetTypesList();
  }, []);

  const onTxtIssueTimeChanged = (date: Date) => {
    if (date) setIssueDate(date);
  };

  const onDdlAssetTypesChanged = (value: string) => {
    if (!value) {
      setDdlAssetTypes("");
      setSelectedAssetsNos([]);
      setAssetsNos([]);
      setBtnConfirmDisabled(true);
      return;
    }

    setDdlAssetTypes(value);
    getAssetsList(value);
  };

  const onAssetSelected = (event: any) => {
    const selections = event.target.value;
    setSelectedAssetsNos(selections);

    const lastItem = selections[selections.length - 1];

    if (lastItem) {
      selections.pop();
      const sameItem = selections.find((value: any) => value === lastItem);
      if (sameItem === undefined) {
        selections.push(lastItem);
      }
    }

    if (selections.length > 0 && isValidEmployee) {
      setBtnConfirmDisabled(false);
    } else {
      setBtnConfirmDisabled(true);
    }
  };

  const verifyEmployeeId = async (e: any) => {
    const employeeId = e.target.value;

    if (!employeeId) return;

    const verifyUserEndpoint = `${apiUrl}/auth/verify/employee/${employeeId}`;

    await httpClient
      .get(verifyUserEndpoint)
      .then((res) => {
        if (res.status === 200) {
          setTxtEmployeeIdColor("text-success");
          setIsValidEmployee(true);
          if (selectedAssetNos.length > 0) {
            setBtnConfirmDisabled(false);
          } else {
            setBtnConfirmDisabled(true);
          }
        } else {
          setIsValidEmployee(false);
          setBtnConfirmDisabled(true);
          showToast("error", "Entered employee Id is not correct.");
          setTxtEmployeeIdColor("text-error");
        }
      })
      .catch(() => {
        setIsValidEmployee(false);
        setBtnConfirmDisabled(true);
        showToast("error", "Entered employee Id is not correct.");
        setTxtEmployeeIdColor("text-error");
      });
  };

  const onBtnConfirmClicked = async () => {
    if (selectedAssetNos.length === 0) {
      showToast("error", "No assets selected");
      return;
    }

    const assignedAssets = selectedAssetNos.map((ast) => ({
      assetNo: ast,
    }));

    const assignmentDto = {
      employeeId,
      issuanceDate: formatDate(
        issueDate || currentDate,
        "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"
      ),
      assets: assignedAssets,
    };

    const assignmentEndpoint = `${apiUrl}/resources/assets/issue`;

    setBtnConfirmDisabled(true);
    setBtnConfirmText("Confirming.....");

    await httpClient
      .post(assignmentEndpoint, assignmentDto)
      .then((res) => {
        if (res.status === 200) {
          setDdlAssetTypes("");
          setSelectedAssetsNos([]);
          setAssetsNos([]);
          setBtnConfirmDisabled(true);
          setBtnConfirmText("Confirm");
          showToast("success", "Assets issued successfully!");
          onAssetIssued();
        } else {
          setBtnConfirmDisabled(false);
          setBtnConfirmText("Confirm");
          showToast("error", "Failed to issue assets, please try again.");
        }
      })
      .catch(() => {
        setBtnConfirmDisabled(false);
        setBtnConfirmText("Confirm");
        showToast("error", "Failed to issue assets, please try again.");
      });
  };

  return (
    <>
      <div className="flex mb-5 gap-4">
        <div className="flex-1">
          <DatePicker
            disabled={(date) => PREV_DAY_DATE > date || PREV_DAY_DATE < date}
            selectedDate={issueDate}
            onSelectDate={onTxtIssueTimeChanged}
          />
        </div>

        <div className="flex-1">
          <Input
            placeholder="Enter Employee Id"
            className={`w-full ${txtEmployeeIdColor}`}
            value={employeeId}
            onChange={(e) => {
              setEmployeeId(e.target.value);
            }}
            onBlur={verifyEmployeeId}
          />
        </div>

        <div className="flex-1">
          <Combobox
            value={ddlAssetTypes}
            data={assetTypes}
            placeholder="Select Asset Type"
            setValue={onDdlAssetTypesChanged}
          />
        </div>
      </div>
      <MultiSelect
        data={assetNos}
        value={selectedAssetNos}
        onChange={onAssetSelected}
        placeholder="Select Asset"
        className="h-10"
      />
      <Button
        variant="secondary"
        disabled={btnConfirmDisabled}
        className="w-max flex ml-auto mt-5"
        onClick={onBtnConfirmClicked}
      >
        {btnConfirmText}
      </Button>
    </>
  );
}

export default AssetsIssuance;
